import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/dJxML6sdS9Vd1dGLitULgq/ChatGPT_Image_6_sept_2026,_19_08_55.png';
const includes = ['120 Ready-to-Teach Classes', '6 Professional Volumes', '5 Premium Bonuses', 'Instant Digital Access'];
export function OfferSection() {
  return <section id="offer" className="w-full bg-ivory py-10 sm:py-14 lg:py-18" aria-labelledby="offer-heading" data-id="element-129" data-mp="icosp5ice2do">
      <div className="mx-auto w-full max-w-xl px-5 sm:px-8" data-id="element-130" data-mp="mgo81krvyv5g">
        <div className="rounded-[2rem] border border-gold/50 bg-cream p-1.5 shadow-card" data-id="element-131" data-mp="rf7r9df3hsu4">
          <div className="rounded-[1.7rem] border border-gold/25 bg-ivory px-5 py-7 text-center sm:px-8 sm:py-9" data-id="element-132" data-mp="wboiighlcnbf">
            <div className="flex justify-center" data-id="element-133" data-mp="2t6ued3vv93lb">
              <SectionLabel data-id="element-134" data-mp="2y44epeksmznx">The complete offer</SectionLabel>
            </div>

            <h2 id="offer-heading" className="mt-3 font-serif text-[1.35rem] font-semibold uppercase leading-tight text-ink sm:text-3xl" data-id="element-135" data-mp="2y678m9p2hcxx">
              Yoga Teacher System™
            </h2>

            <img src={MOCKUP} alt="Yoga Teacher System — the complete bundle of six volumes and bonus resources" className="mx-auto mt-3 w-[72%] max-w-xs sm:w-[68%] sm:max-w-sm" width={1536} height={1024} loading="lazy" data-id="element-136" data-mp="swxgy4jbbjdq" />

            <ul className="mx-auto mt-3 grid max-w-sm gap-1.5" data-id="element-137" data-mp="1gol183m2jw71">
              {includes.map(item => <li key={item} className="flex items-center justify-center gap-2.5 rounded-xl bg-cream/70 px-3 py-2.5" data-id="element-138" data-mp="1ck4vc2cggort">
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-139" data-mp="16syibf456f5">
                    <CheckIcon className="h-2.5 w-2.5 text-ivory" aria-hidden="true" data-id="element-140" data-mp="3sbsorns9fz5v" />
                  </span>
                  <span className="text-[0.85rem] font-medium leading-snug text-ink sm:text-[0.92rem]" data-id="element-141" data-mp="3tvasdysa34ak">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-7 border-t border-gold/25 pt-7" data-id="element-142" data-mp="3ksry432k5zzx">
              <p className="font-serif text-[3.5rem] font-semibold leading-none text-forest sm:text-7xl" data-id="element-143" data-mp="3ou50g36fzl23">
                $17{' '}
                <span className="align-baseline text-[0.4em] font-semibold uppercase tracking-label text-ink" data-id="element-144" data-mp="3b1x4gdmzfy4g">
                  USD
                </span>
              </p>
              <p className="mt-3 text-[0.8rem] leading-snug text-muted sm:text-sm" data-id="element-145" data-mp="316dee7v3ntnm">
                Pay in your local currency.
              </p>
              <p className="mt-3 flex items-center justify-center gap-2 text-[0.62rem] font-semibold uppercase tracking-label text-ink" data-id="element-146" data-mp="362c4q0zznlqo">
                <span className="h-px w-6 bg-gold/50" aria-hidden="true" data-id="element-147" data-mp="2x48pfmfljl7b" />
                One-time payment
                <span className="h-px w-6 bg-gold/50" aria-hidden="true" data-id="element-148" data-mp="2dh5hi1ftzw2d" />
              </p>

              <div className="mt-6" data-id="element-149" data-mp="28jnf6twbkf3c">
                <CtaButton href="https://yogateachersystem.impultienda.ar/checkout" label="Get instant access" microcopy="Instant Digital Access • 7-Day Guarantee • No Subscription" data-id="element-150" data-mp="28korf1p2n7mn" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}